export const AppType = {
  NATIVE: "NATIVE",
  USER: "USER",
  ORGANIZATION: "ORGANIZATION",
};
